import React from "react";
import { SuccessfullStep } from "../../../components";

export const SuccessfullStepPage = () => {
  return <SuccessfullStep />;
};
